import React from 'react'
import { message, notification, Modal } from 'antd'
import Payment    from 'payment'
import prettysize from '../../../../utils'
import CloudFlyerAPI from '../../../../api/CloudFlyerAPI'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import s3                 from './s3'
import { selectionChanged }          from '../../../../actions/s3-direct-actions'
import { fetchBucketContent }        from '../../../../actions/cloud-files-system-actions'
import { refresh_profile }           from '../../../../actions/auth'
import {on_top_notification_changed, S3_DIRECT_QUOTA_WARNING_SIZE} from '../../../../actions/content-alert-actions'

import LocalControls   from '../controls'
import Files           from './files'
import EmptyState      from '../empty-state'
import PaymentForm     from '../../../Billing/PaymentForm'
import {sanitize_path} from '../../../../utils'

import '../styles.scss'

let states = {}
let $this  = null

class index extends React.Component {

  constructor (props) {
    super(props)
    $this             = this
    $this.provider    = props.provider ? props.provider : 'state'

    if(states[$this.provider]){
      $this.state = states[$this.provider]
    } else {
      $this.state = {
        busy          : true,
        dl_busy       : false,
        current_limit : 30,
        files         : [],

        selection : {
          size  : 0,
          cost  : 0,
          count : 0
        },

        billing_loading    : false,
        billing_valid      : false,
        billing_alert      : false,

        billing :{
          number: '',
          name: '',
          exp: '',
          cvc: '',
          focused: ''
        }
      }
    }

    $this.props.selectionChanged($this.state.selection)
    $this.uploads_promises = []
  }

  componentDidMount() {
    $this.add_drop_zone()

    if($this.props.user){
      const {first_name, last_name, has_billing_info, s3_quota} = $this.props.user

      if(!has_billing_info && s3_quota <= S3_DIRECT_QUOTA_WARNING_SIZE){
        const message = "Hey " + first_name + ' ' + last_name + ", we noticed you didn’t set up a payment method, we need you to sort it out before handling your files :)"

        $this.setState({ billing_alert : true })

        $this.props.on_top_notification_changed(message, ()=> {$this.setState({ billing_modal_visible: true })}, 'Set payment method')
      }
    }
  }

  componentDidUpdate() {
    $this.add_drop_zone()
  }

  componentWillUnmount() {
    states[$this.provider] = $this.state

    if(states[$this.provider].billing_alert){
      $this.props.on_top_notification_changed()
    }
  }

  componentWillReceiveProps(props) {
    $this.setState({alert_content:props.contentAlert})
  }

  add_drop_zone = ()=> {

    if ($this.refs.dir_upload) {
      $this.refs.dir_upload.directory = true
      $this.refs.dir_upload.allowdirs = true
      $this.refs.dir_upload.webkitdirectory = true
      $this.refs.dir_upload.mozdirectory = true
      $this.refs.dir_upload.msdirectory = true
      $this.refs.dir_upload.odirectory = true
    }

    let dropzone = document.getElementById('dropzone')
    if(dropzone){
      dropzone.addEventListener('drop', (e)=> {
        e.stopPropagation()
        e.preventDefault()

        let items = e.dataTransfer.items, n, item;
        for(n = 0; n < items.length; n++) {
          item = items[n].webkitGetAsEntry();

          if(!item){
            continue
          }

          if(item.isDirectory) {
            item.type = 'directory'
            $this.state.files[item.name] = item

          } else if (item.isFile) {
            item.file(function(file) {
              $this.state.files[file.name] = file
            })
          }
        }

        $this.setState({
          files : $this.state.files
        }, ()=> $this.props.selectionChanged($this.calculate_selection()))
      }, false)
    }
  }

  onDrop = files => {
    for (let key in files) {
      $this.state.files[files[key].name] = files[key]
    }

    $this.setState({
      files : $this.state.files
    }, ()=> $this.props.selectionChanged($this.calculate_selection()))
  }

  on_select_files = (e) =>{
    if(!e || !e.target.files){
      return $this.refs.file_upload.click()
    }

    let files = Array.from(e.target.files)
    for (let key in files) {
      $this.state.files[files[key].name] = files[key]
    }

    e.target.value = ''
    $this.setState({
      files  : $this.state.files
    }, ()=> $this.props.selectionChanged($this.calculate_selection()))
  }

  on_select_folders = (e) =>{
    if(!e || !e.target.files){
      return $this.refs.dir_upload.click()
    }

    let files = Array.from(e.target.files)

    $this.state.files[(files[0]||{}).webkitRelativePath.split("/")[0]] = {
      name  : (files[0]||{}).webkitRelativePath.split("/")[0],
      type  : 'directory',
      files : files
    }

    $this.setState({
      files: $this.state.files
    }, ()=> $this.props.selectionChanged($this.calculate_selection($this.state.files)))
  }

  on_upload_files = () =>{

    if(!$this.props.bucket || !$this.props.cloud)
      return message.warn('Please select a bucket before uploading.')

    console.log(`on_upload_files${$this.provider} ${($this.props.bucket || {}).bucket_name} ${$this.props.path}`)

    if($this.props.bucket && (!$this.s3 || ($this.props.bucket.cloud_account_id !== ($this.bucket||{}).cloud_account_id))){
      let cloud_account = $this.props.cloud||{} //(props.cloudAccounts.filter(c=> c.id === props.bucket.cloud_account_id)||[])[0]||{}
      if(!$this.s3 || cloud_account.endpoint !== $this.service_url){
        $this.service_url   = cloud_account.endpoint ? sanitize_path(cloud_account.endpoint, true) : null
        $this.bucket        = $this.props.bucket
        $this.s3 = new s3($this.service_url)
      }
    }

    let files = []
    let {quota:{s3_acceleration:quota={}}, has_billing_info, role={}} = $this.props.user

    for (let key in $this.state.files) {
      let item = $this.state.files[key]

      if(item.type === 'directory' && !item.id){
        if($this.props.s3Acceleration && !has_billing_info){
          return message.error('You can not use upload directory feature while on free plan')
        }

        $this.upload_dir(item,
          $this.props.bucket.bucket_name,
          $this.props.bucket.region,
          $this.props.cloud.id,
          $this.props.cloud.info.access_key,
          $this.props.s3Acceleration,
          $this.props.access_control,
          $this.props.path||'/')
      } else if(!item.id) {
        files.push(item)
      }
    }

    if(files.length <= 0)
      return

    /*return $this.setState({
      billing_modal_visible : true
    }, ()=> {
      if(document.querySelector('[name="number"]')){
        //Payment.formatCardNumber(document.querySelector('[name="number"]'))
        Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))
        Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
      }
    })*/

    let total_size = files.map(f => f.size).reduce((prev, curr) => prev + curr)
    if($this.props.s3Acceleration && quota.total >= 0 && total_size > (quota.total - quota.used)){
      if(role.title === 'Owner' && !has_billing_info){
        return $this.setState({billing_modal_visible:true}, ()=> {
          if(document.querySelector('[name="number"]')){
            //Payment.formatCardNumber(document.querySelector('[name="number"]'))
            //Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))
            Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
          }
        })
      }
      return Modal.warning({
        title:'Transfers Quota Limit',
        content:(
          <div>
            <p>Please contact account administrator to add Credit Card information to your organization.</p>
            <p>You have {prettysize(quota.total - quota.used)} remaining on your quota.</p>
          </div>
        ),
        onOk:()=> {
          $this.props.refresh_profile(true)
        }
      })
    }

    $this.upload_files(files,
      $this.props.bucket.bucket_name,
      $this.props.bucket.region,
      $this.props.cloud.id,
      $this.props.cloud.info.access_key,
      $this.props.s3Acceleration,
      $this.props.access_control,
      $this.props.path || '/')
  }

  on_remove_file = file => {

    delete $this.state.files[file.id]
    delete $this.state.files[file.name]

    $this.setState({files: $this.state.files}, ()=> $this.props.selectionChanged($this.calculate_selection()))
  }

  on_error_fix = upload => {
    CloudFlyerAPI.transfer.update_bucket_config(true, upload.s3Acceleration, true, upload.cloud_account_id, upload.bucket_name)
      .then(function () {
        upload.$status = 'active'
        $this.forceUpdate()

        upload.evaporate.pause(upload.id, {force: true})
          .then(function () {
            upload.evaporate.resume(upload.id, {force: true})
              .catch(console.error)
          })
          .catch(function () {
            upload.evaporate.resume(upload.id, {force: true})
              .catch(console.error)
          })
      })
      .catch(function (err) {
        if((err||{}).data.s3_acceleration){
          upload.$error = (err||{}).data.s3_acceleration
          message.error((err||{}).data.s3_acceleration)
        }

        if((err||{}).data.cors){
          upload.$error = (err||{}).data.s3_acceleration
          message.error(err.cors)
        }
      })
  }

  calculate_selection = ()=> {
    let files = $this.state.files
    let selection = {
      size  : 0,
      cost  : 0,
      count : 0
    }

    for (let key in files) {
      let queue = files[key]
      if(queue.size){
        selection.size  += queue.size
        selection.count += 1
      } else if (queue.files) {
        for (let fkey in queue.files) {
          selection.size  += queue.files[fkey].size
          selection.count += 1
        }
      }
    }

    $this.setState({
      selection: selection
    })
    return selection
  }

  fetch_bucket_content = ()=>{
    $this.props.fetchBucketContent({...$this.props, ...$this.state})
  }

  upload_files = (upload_items, bucket_name, bucket_region, cloud_account_id, access_key,
                  s3Acceleration, access_control, current_path) => {
    $this.s3.create_bucket_uploader(bucket_name, bucket_region, access_key, cloud_account_id, s3Acceleration, uploader => {
      for (let i = 0; i < upload_items.length; i++) {
        if(upload_items[i].isDirectory){
          if(!upload_items[i].uploads_promises){
            upload_items[i].uploads_promises = []
          }

          upload_items[i].uploads_promises.push(
            $this.add_dir(
              upload_items[i], bucket_name, cloud_account_id,
              access_key, s3Acceleration, access_control,
              current_path, uploader
            )
          )
        } else {
          $this.uploads_promises.push(
            $this.add(
              upload_items[i], bucket_name, cloud_account_id,
              access_key, s3Acceleration, access_control,
              current_path, uploader
            )
          )
        }
      }

      $this.uploads_completed = Promise.all($this.uploads_promises)
        .then(()=> {
          $this.fetch_bucket_content()
          $this.calculate_selection()
        },  reason => {
          $this.calculate_selection()
          console.error(reason);
        })

      $this.calculate_selection()
    })
  }

  upload_dir = (dir, bucket_name, bucket_region, cloud_account_id, access_key,
                s3Acceleration, access_control, current_path) => {

    $this.s3.create_dir_uploader(bucket_name, bucket_region, access_key, cloud_account_id, s3Acceleration, (uploader) => {
      $this.add_dir(
        dir, bucket_name, cloud_account_id,
        access_key, s3Acceleration, access_control,
        current_path, uploader
      )
    })
  }

  add = (file, bucket_name, cloud_account_id, access_key,
         s3Acceleration, access_control, current_path, uploader) => {

    let file_name = decodeURIComponent((current_path === '/' ? '' : current_path) + '/' + (file.fullPath ? file.fullPath : file.name))
    file_name     = file_name.replace(/^\/+/g, '')
    file_name     = file_name.replace(/([^:]\/)\/+/g, "$1")

    let file_key  = decodeURIComponent(bucket_name + '/' + file_name)

    let task = {
      name     : file_name,
      file     : file,
      size     : file.size,
      id       : file_key,
      queued                : true,
      s3Acceleration        : s3Acceleration,
      access_control        : access_control,
      bucket_name           : bucket_name,
      cloud_account_id      : cloud_account_id,
      xAmzHeadersAtInitiate : { 'x-amz-acl': access_control },

      started   : ()=> $this.on_started(uploader.pendingFiles[file_key]),
      progress  : (progress, stat)=> $this.on_progress(uploader.pendingFiles[file_key], progress, stat),
      complete  : (xhr, awsObjectKey, stats)=> $this.on_complete(uploader.pendingFiles[file_key], awsObjectKey, stats),
      error     : (msg)=> $this.on_error(uploader.pendingFiles[file_key], msg),
      warn      : (msg)=> $this.on_warn(uploader.pendingFiles[file_key], msg),
    }

    if(uploader.directory){
      uploader.directory.uploads[task.id] = task
      $this.setState({})
    } else {
      $this.state.files[file.name] = task
      $this.setState({
        files: $this.state.files
      })
    }

    return uploader
      .add(task, {
        bucket         : bucket_name,
        aws_key        : access_key,
        s3Acceleration : s3Acceleration,
        partSize       : $this.s3.calculate_optimal_part_size(file.size)
      })
      .then(()=> {
        console.info('upload completed successfully ' + file.name)
      },  (err)=> {
        console.info('File did not upload successfully:', err)

        let upload = $this.state.files[task.name]
        if(!upload)
          upload = $this.state.files[task.id]

        if(upload && upload.type === 'directory'){
          upload.$status   = 'error'
          upload.$errorMsg = err
          upload.$error    = err
        }

        message.error(err)
      })
  }

  add_dir = (dir_entry, bucket_name, cloud_account_id, access_key,
             s3Acceleration, access_control, current_path, uploader) => {

    let dir_name = decodeURIComponent((current_path === '/' ? '' : current_path) + '/' + dir_entry.name)
    dir_name     = dir_name.replace(/^\/+/g, '');
    dir_name     = dir_name.replace(/([^:]\/)\/+/g, "$1")

    $this.state.files[dir_name] = uploader.directory = {
      DirectoryEntry   : dir_entry,
      DirectoryEntries : [],
      FileEntries      : [],
      files            : dir_entry.files,
      resolve_next     :  ()=> {},

      bucket_name      : bucket_name,
      cloud_account_id : cloud_account_id,
      access_key       : access_key,
      s3Acceleration   : s3Acceleration,
      access_control   : access_control,
      uploader         : uploader,
      name             : dir_name,
      current_path     : current_path,
      concurrent       : 4,

      size           : null,
      count          : dir_entry.files ? dir_entry.files.length : null,
      percent        : 0,
      status         : 2,
      uploaded_count : 0,
      uploaded_size  : 0,
      dir_count      : 0,
      startTime      : new Date(),
      endTime        : null,
      uploads        : {},
      type           : 'directory',

      on_complete    :  (upload) => {
        let dir = $this.state.files[dir_name]
        dir.uploaded_count ++
        dir.uploaded_size  += upload.file.size

        delete dir.uploads[upload.id]

        console.info('Total loaded files: '  + dir.FileEntries.length)
        console.info('Upload queue: '        + $this.s3.keys_count(dir.uploads))
        console.info('files uploaded: '      + dir.uploaded_count)

        $this.setState({})

        if(dir.status !== 4){
          $this.s3.add_more_files(dir, $this.add, $this.fetch_bucket_content)
        }
      }
    }

    let on_resolved =  (items, resolve_next)=> {
      $this.state.files[dir_name].resolve_next = resolve_next

      for (let key in items) {
        if(items[key].name.startsWith('.')){
          continue
        }

        if(items[key].isFile){
          $this.state.files[dir_name].FileEntries.push(items[key])
        } else if (items[key].isDirectory) {
          $this.state.files[dir_name].DirectoryEntries.push(items[key])
        }
      }

      if(!resolve_next && $this.state.files[dir_name].DirectoryEntries.length > 0){
        $this.state.files[dir_name].DirectoryEntry = $this.state.files[dir_name].DirectoryEntries.pop()
        $this.state.files[dir_name].resolve_next   = $this.s3.load_dir_files($this.state.files[dir_name].DirectoryEntry, on_resolved)
      }

      $this.s3.add_more_files($this.state.files[dir_name], $this.add, $this.fetch_bucket_content)
    }

    if(dir_entry.files){
      $this.s3.add_more_files($this.state.files[dir_name], $this.add, $this.fetch_bucket_content)

      for (let key in $this.state.files[dir_name].files) {
        $this.state.files[dir_name].size += $this.state.files[dir_name].files[key].size
      }
    } else {
      $this.s3.load_dir_files($this.state.files[dir_name].DirectoryEntry, on_resolved)
    }
  }

  on_started     =  upload => {
    upload.$percent = 1;

    if(upload.evaporate.directory){
      upload.evaporate.directory.uploads[upload.id] = upload
    } else {
      delete $this.state.files[upload.file.name]
      $this.state.files[upload.id] = upload

      $this.setState({files: $this.state.files})
    }
  }

  on_progress    =  (upload, progress, stat)  => {
    if(progress > 0 && progress < 1 && !upload.$stopped && !upload.$complete && !upload.$cancelled && !upload.$paused){
      delete upload.$errorMsg;
      delete upload.$error;

      upload.$status = 'uploading...'
    } else if (progress === 1) {
      delete upload.$status
    }

    if(upload.$percent < progress * 100){
      upload.$percent = (progress * 100).toFixed(2)
      upload.$status  = 'active'
    }

    upload.$readableSpeed = stat.readableSpeed
    upload.$remainingSize = stat.remainingSize
    upload.$secondsLeft   = stat.secondsLeft
    upload.$speed         = stat.speed
    upload.$totalUploaded = stat.totalUploaded

    if(!$this.last_update){
      $this.setState({files: $this.state.files})
      return $this.last_update = new Date()
    }

    if((new Date().getTime() - $this.last_update.getTime()) > 1000){
      $this.setState({files: $this.state.files})
      $this.last_update = new Date()
    }
  }

  on_complete    =  upload =>{
    upload.endTime  = new Date()
    upload.$percent = 100
    delete upload.$status

    if(upload.evaporate.directory){
      upload.evaporate.directory.on_complete(upload)
    } else {
      if ((upload.access_control === 'public-read' || upload.access_control === 'public-read-write') && upload.partsOnS3[0] && upload.partsOnS3[0].awsRequest) {
        upload.$url = upload.partsOnS3[0].awsRequest.awsUrl + '/' + $this.id
      }

      delete $this.state.files[upload.file.name]
      delete $this.state.files[upload.id]
      $this.setState({files: $this.state.files})

      notification.success({
        message: 'Upload Complete',
        description: decodeURIComponent(upload.name + ' uploaded to ' + upload.bucket_name + ' successfully')
      })

      $this.s3.send_report([upload], upload.s3Acceleration)
      $this.props.refresh_profile(true)
      $this.props.on_complete()
    }
  }

  on_error       =  (upload, msg, err)  =>{
    console.error('Upload #%f on_error, msg = %s', upload.$id, msg, err)

    upload.$status = 'exception'
    upload.$error  = msg + err

    notification['error']({
      message: 'Upload Failed',
      description: upload.name + ' upload to ' + upload.bucket_name + ' failed'
    })
  }

  on_warn        =  (upload, msg, err)  =>{
    if(upload.$last_err && Math.abs(upload.$last_err.getTime() - new Date().getTime()) > 10000){
      upload.$status = 'exception'
      upload.$error  = msg + err

      delete upload.$last_err;
    }

    if(!upload.$last_err){
      upload.$last_err = new Date();
    }

    console.error('Upload #%f on_warn, msg = %s', upload.$id, msg, err);
  }

  on_focus = target => {
    $this.setState({
      focused: target.name,
    })
  }

  on_billing_change = target => {
    const billing = $this.state.billing

    if (target.name === 'number') {
      billing[target.name] = target.value.replace(/ /g, '')
    }
    else if (target.name === 'expiry') {
      billing[target.name] = target.value.replace(/[ \/]/g, '')
    }
    else {
      billing[target.name] = target.value
    }

    $this.setState({
      billing: billing
    })
  }

  billing_callback = (type, isValid) => {
    $this.setState({billing_valid : isValid})
  }

  on_cancel_billing = () => {
    $this.setState({ billing_modal_visible: false })
  }

  on_save_billing = () => {
    $this.form.validateFields((err, values) => {
      if (err) {
        return message.error('Please fill required fields')
      }

      $this.setState({billing_loading: true})

      const { name, number, expiry, cvc } = values
      let {email, first_name, last_name} = $this.props.user

      let subscription = {
        customer_subscription: {
          subscription: {
            product_handle : 'CloudFlyer-free',
            coupon_code    : '',

            customer_attributes: {
              first_name : first_name,
              last_name  : last_name,
              email      : email
            },

            credit_card_attributes: {
              full_number      : number,
              expiration_month : expiry.split('/')[0],
              expiration_year  : expiry.split('/')[1],
              billing_address  : '',
              billing_city     : '',
              billing_state    : '',
              billing_country  : 'USA',
              billing_zip      : ''
            }
          }
        }
      }

      CloudFlyerAPI.billing.subscriptions.new_customer(subscription)
        .then(()=> {
          $this.setState({billing_loading: false, billing_modal_visible:false}, ()=>{
            $this.props.refresh_profile()
            message.success('Subscribed successfully')
          })
        })
        .catch(function (err) {
          $this.setState({billing_loading: false}, ()=> $this.props.refresh_profile())

          if(((err.response||{}).data||{})){
            if(((err.response||{}).data||{}).chargify_errors){
              return message.error(((err.response||{}).data||{}).chargify_errors[0])
            }
            message.error(((err.response||{}).data||{}).message)
          } else {
            message.error(err.message)
          }
        })
    })
  }

  save_ref = form => $this.form = form

  render() {
    const {billing_modal_visible, focused, billing_loading} = $this.state
    const {name, number, expiry, cvc} = $this.state.billing

    return (
      <div className='local-files-system s3 center-child'>
        <div className='content'>
          {
            Object.keys($this.state.files).length > 0 ?
              <Files files={Object.values($this.state.files).sort((a, b)=> {
                return a.$percent < b.$percent})}
                     on_remove={$this.on_remove_file.bind($this)}
                     on_error_fix={$this.on_error_fix.bind($this)}/> :
              <EmptyState on_select_files={$this.on_select_files.bind($this)}
                          onDrop={$this.onDrop.bind($this)}
                          on_select_folders={$this.on_select_folders.bind($this)}/>
          }

          {
            Object.keys($this.state.files).length > 0 ?
              <LocalControls on_select_files={$this.on_select_files.bind($this)}
                             on_select_folders={$this.on_select_folders.bind($this)}
                             on_upload_files={$this.on_upload_files.bind($this)}
                             disabled={!$this.props.bucket}
              /> : null
          }
        </div>

        <div className={'hidden'}>
          <input ref="file_upload" type="file" name="files[]" multiple
                 onChange={$this.on_select_files.bind($this)}/>

          <input ref="dir_upload" type="file" multiple
                 onChange={$this.on_select_folders.bind($this)}/>
        </div>

        <PaymentForm title   = {''}
                     ref     = {$this.save_ref.bind($this)}
                     visible = {billing_modal_visible}
                     loading = {billing_loading}

                     name    = {name}
                     number  = {number}
                     expiry  = {expiry||'##/##'}
                     cvc     = {cvc}
                     focused = {focused}

                     on_cancel = {$this.on_cancel_billing.bind($this)}
                     on_save   = {$this.on_save_billing.bind($this)}
                     on_focus  = {$this.on_focus.bind($this)}
                     on_change = {$this.on_billing_change.bind($this)}
                     callback  = {$this.billing_callback.bind($this)}
        />
      </div>
    )
  }
}

export default withRouter(connect(({auth={}, localFilesSystem={}, cloudFilesSystem={}, cloudAccounts=[]}) => {
  return {
    ...localFilesSystem,
    user : {...auth.user, ...{key:Math.random()}}
  }
}, (dispatch) => bindActionCreators({selectionChanged, fetchBucketContent, on_top_notification_changed, refresh_profile: refresh_profile}, dispatch))(index))

